import { 
    Add,
    Album,
    Computer, 
    GridView, 
    History, 
    List, 
    Person, 
    RadioButtonChecked, 
    RadioButtonUnchecked, 
    Smartphone, 
    Speaker 
} from "@mui/icons-material";

const DEVICE_ICONS = {
    "computer": Computer,
    "smartphone": Smartphone,
    "speaker": Speaker
};

export const getDeviceIcon = (deviceType) => {
    const DeviceIcon = DEVICE_ICONS[deviceType.toLowerCase()];

    if(!DeviceIcon)
    {
        return <Computer fontSize="inherit" />
    }

    return <DeviceIcon fontSize="inherit" />
}

export const getActiveIcon = (active) => {
    if(active)
    {
        return <RadioButtonChecked fontSize="inherit" color="success" />
    }

    return <RadioButtonUnchecked fontSize="inherit" color="error" />
}

const ORDER_ICONS = {
    playedRecently: History,
    addedRecently: Add,
    alphabetical: Album,
    creator: Person
}

export const getOrderIcon = (order) => {
    const OrderIcon = ORDER_ICONS[order];

    if(!OrderIcon)
    {
        return <History fontSize="inherit" />;
    }

    return <OrderIcon fontSize="inherit" />
}

const LAYOUT_ICONS = {
    "grid": GridView,
    "list": List
}

export const getLayoutIcon = (layout) => {
    const LayoutIcon = LAYOUT_ICONS[layout];

    if(!LayoutIcon)
    {
        return <GridView fontSize="inherit" />
    }

    return <LayoutIcon fontSize="inherit" />
}